import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLike, pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {GetAttributeSetParameters} from "#template/nodes/geometry-graph/attribute-set/get-attribute-set/geometry-get-attribute-set-node"
import {
    GeometryGetAttributeSetNode,
    getAttributeSetParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/get-attribute-set/geometry-get-attribute-set-node"

export type PointGeometryGetAttributeSetParameters = GetAttributeSetParameters<PointGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometryGetAttributeSetParameters> = {
    nodeClass: "PointGeometryGetAttributeSet",
    validation: {
        parameters: getAttributeSetParametersSchema(pointGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryGetAttributeSet
    extends GeometryGetAttributeSetNode<0, PointGeometryAttributeSetLikeNode>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
